import React, { useState } from "react";

const InspectionModal = () => {

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    pincode: "",
  });

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const response = await fetch(
        // "http://localhost:5000/book-inspection",
          "https://totalpestcontrol.co.in/book-inspection",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (data.success) {

        alert(data.message);

        setFormData({
          fullName: "",
          email: "",
          phone: "",
          address: "",
          city: "",
          pincode: "",
        });

      } else {

        alert(data.message);

      }

    } catch (error) {

      console.log(error);

      alert("Something went wrong");

    } finally {

      setLoading(false);

    }

  };

  const isFormValid =
    formData.fullName.trim() !== "" &&
    formData.email.trim() !== "" &&
    formData.phone.trim() !== "" &&
    formData.address.trim() !== "" &&
    formData.city.trim() !== "" &&
    formData.pincode.trim() !== "";

  return (

    <div
      className="modal fade"
      id="inspectionModal"
      tabIndex="-1"
    >

      <div className="modal-dialog modal-dialog-centered">

        <div className="hero-form">

          <h5>Book A Free Inspection!</h5>

          <p>
            Enjoy 6 Months of Guaranteed Protection!
          </p>

          <div className="form-scroll">

            <div className="floating-group">

              <input
                type="text"
                name="fullName"
                placeholder=" "
                value={formData.fullName}
                onChange={handleChange}
                required
              />

              <label>
                Full Name <span>*</span>
              </label>

            </div>

            <div className="floating-group">

              <input
                type="email"
                name="email"
                placeholder=" "
                value={formData.email}
                onChange={handleChange}
                required
              />

              <label>
                Email <span>*</span>
              </label>

            </div>

            <div className="floating-group">

              <input
                type="text"
                name="phone"
                placeholder=" "
                value={formData.phone}
                onChange={handleChange}
                required
              />

              <label>
                Phone <span>*</span>
              </label>

            </div>

            <div className="floating-group">

              <input
                type="text"
                name="address"
                placeholder=" "
                value={formData.address}
                onChange={handleChange}
                required
              />

              <label>
                Address <span>*</span>
              </label>

            </div>

            <div className="floating-group">

              <input
                type="text"
                name="city"
                placeholder=" "
                value={formData.city}
                onChange={handleChange}
                required
              />

              <label>
                City <span>*</span>
              </label>

            </div>

            <div className="floating-group">

              <input
                type="text"
                name="pincode"
                placeholder=" "
                value={formData.pincode}
                onChange={handleChange}
                required
              />

              <label>
                Pin Code <span>*</span>
              </label>

            </div>

          </div>

          <button
            className="send-btn"
            disabled={!isFormValid || loading}
            onClick={handleSubmit}
          >

            {loading ? "Sending..." : "Send"}

          </button>

          <button
            className="form-close-btn"
            data-bs-dismiss="modal"
          >
            ✖
          </button>

        </div>

      </div>

    </div>

  );

};

export default InspectionModal;